import kpiIndices from '@/data/kpiIndices.json';

const DEFAULT_INDEX_ID = -1;

export function assignKpiPerformanceIndex(controls) {
  for (const control of controls) {
    const match = kpiIndices.find(idx =>
      control.isKpiGroup
        ? idx.kpiGroupId === control.kpiId && !idx.kpiId
        : idx.kpiId === control.kpiId
    );
    control.indexId = match?.indexId ?? DEFAULT_INDEX_ID;
    if (control.children?.length) assignKpiPerformanceIndex(control.children);
  }
}

export function assignKpiPerformanceIndexOverview(controls) {
  for (const control of controls) {
    const match = kpiIndices.find(idx =>
      control.type === 'group'
        ? idx.kpiGroupId === control.kpiGroupId
        : idx.kpiId === control.kpiId
    );
    control.indexId = match?.indexId ?? DEFAULT_INDEX_ID;
    if (control.children?.length) assignKpiPerformanceIndexOverview(control.children);
  }
}
